import React from 'react';
import { AccumulationChartComponent, AccumulationSeriesCollectionDirective, AccumulationSeriesDirective, Inject, AccumulationLegend, PyramidSeries, AccumulationTooltip, AccumulationDataLabel } from '@syncfusion/ej2-react-charts';
import { PyramidData } from '../../data/dummy';
import { Header } from '../../components';
import { useStateContext } from '../../contexts/ContextProvider';


const Pyramid = () => {
  const { currentMode } = useStateContext();

  return (
    <div className='m-4 md:m-10 mt-24 p-10 bg-white dark:bg-secondary-dark-bg rounded-3xl'>
      <Header category='Pyramid' title='Food Calories' />
      <div className='w-full'>
        <AccumulationChartComponent id='pyramid-chart' tooltip={{ enable: true }} background={currentMode === 'Dark' ? '#33373E' : '#fff'}>
          <Inject services={[AccumulationLegend, PyramidSeries, AccumulationTooltip, AccumulationDataLabel]}/>
          <AccumulationSeriesCollectionDirective>
            <AccumulationSeriesDirective name='Food' dataSource={PyramidData} xName='x' yName='y' type='Pyramid' gapRatio={0.2}
                width="45%" height="80%" neckWidth="15%" explode emptyPointSettings={{ mode: 'Drop', fill: 'red' }}
                dataLabel={{
                  visible: true,
                  position: 'Inside',
                  name: 'text',
                }}>
            </AccumulationSeriesDirective>
          </AccumulationSeriesCollectionDirective>
        </AccumulationChartComponent>;      
      </div>
    </div>
  )
}

export default Pyramid